/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecuteCommandDocumentRequest extends models.AwsSsmBaseExecuteDocumentRequest {
    getFixupPrototypeFunction() { return AwsSsmExecuteCommandDocumentRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecuteCommandDocumentRequest>): AwsSsmExecuteCommandDocumentRequest {
        let obj = Object.assign(new AwsSsmExecuteCommandDocumentRequest(), model);
        AwsSsmExecuteCommandDocumentRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecuteCommandDocumentRequest>): AwsSsmExecuteCommandDocumentRequest {
        if (!model) return null;
        return AwsSsmExecuteCommandDocumentRequest.newInstance(<AwsSsmExecuteCommandDocumentRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecuteCommandDocumentRequest) {
        if (!obj) return;

        models.AwsSsmExecuteCommandDocumentRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecuteCommandDocumentRequest): boolean {
        if (models.AwsSsmBaseExecuteDocumentRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmExecuteCommandDocumentRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.timeout_seconds === undefined) {
            this.timeout_seconds = 0;
        }
        if (this.notification_config) {
            models.AwsSsmNotificationConfig.fixupPrototype(this.notification_config);
        }
        if (this.cloud_watch_output_config) {
            models.AwsSsmCommandDocumentCloudWatchOutputConfig.fixupPrototype(this.cloud_watch_output_config);
        }
        if (this.targets) {
            for (let val of this.targets) {
                models.AwsSsmCommandDocumentTarget.fixupPrototype(val);
            }
        }
    }

    /**
     * The IDs of the managed nodes where the command should run.
     */
    instance_ids: Array<string>;

    /**
     * An array of search criteria that targets managed nodes using a Key,Value combination.
     */
    targets: Array<models.AwsSsmCommandDocumentTarget>;

    /**
     * If this time is reached and the command has not already started running, it wont run.
     */
    timeout_seconds: number;

    /**
     * User-specified information about the command.
     */
    comment: string;

    /**
     * The name of the S3 bucket where command execution responses should be stored.
     */
    output_s3_bucket_name: string;

    /**
     * The directory structure within the S3 bucket where the responses should be stored.
     */
    output_s3_key_prefix: string;

    /**
     * The ARN of the AWS IAM service role to use to publish Amazon SNS notifications for Run Command commands.
     */
    service_role_arn: string;

    /**
     * Configurations for sending notifications.
     */
    notification_config: models.AwsSsmNotificationConfig;

    /**
     * Enables AWS Systems Manager to send Run Command output to Amazon CloudWatch Logs.
     */
    cloud_watch_output_config: models.AwsSsmCommandDocumentCloudWatchOutputConfig;

}
